import { IArrowTopTrailerProps } from "interfaces";

const ArrowTopTrailerIcon = ({ className, onClick }: IArrowTopTrailerProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M27.56 20.12C27.56 20.3734 27.4667 20.6267 27.2667 20.8267C26.88 21.2134 26.24 21.2134 25.8534 20.8267L17.16 12.1334C16.52 11.4934 15.48 11.4934 14.84 12.1334L6.14669 20.8267C5.76003 21.2134 5.12003 21.2134 4.73336 20.8267C4.34669 20.44 4.34669 19.8 4.73336 19.4134L13.4267 10.72C14.1067 10.04 15.0267 9.65337 16 9.65337C16.9734 9.65337 17.8934 10.0267 18.5734 10.72L27.2667 19.4134C27.4534 19.6134 27.56 19.8667 27.56 20.12Z" />
        </svg>
    );
};

export default ArrowTopTrailerIcon;
